import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { ProjectState } from "../../types/interface";
import VisionStudioProject from "../../components/VisionStudioProjectModal/Index";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProjectItem, ProjectListProps } from "../../types/interface";
// import Project from "../Project/Project";

const RecentProjects: React.FC<ProjectState> = ({ projects }) => {
  const navigate = useNavigate();
  // const remainingImages = totalImages - completedImages;
  // const remainingPercentage = (remainingImages / totalImages) * 100;
  const remainingImages = 1000 - 1000;
  const remainingPercentage = (remainingImages / 1000) * 100;
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = (e: any) => {
    setOpen(true);
  };

  return (
    <Box
      sx={{
        background: "white",
        borderRadius: "6px",
        // padding: "20px",
        flex: "0 0 23%",
        position: "relative",
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontSize: "1.2rem",
          fontWeight: "600",
          lineHeight: "40px",
          padding: "20px",
          paddingBottom: "0",
        }}
      >
        Recent Projects
      </Typography>
      {projects.length === 3 &&
      projects.every((project) => project?.id === "sample-project") ? (
        <Box sx={{ padding: "12px 20px" }}>
          <Typography
            variant="h3"
            sx={{
              fontSize: "18px",
              fontWeight: "500",
              lineHeight: "26px",
              margin: "8px 0",
            }}
          >
            Get Started on Your First Project
          </Typography>
          <Typography sx={{ color: "#5B6871", lineHeight: "20px" }}>
            Kickstart your first project: Upload, train, and automate AI
          </Typography>
          <Button
            variant="contained"
            sx={{ marginTop: "15px" }}
            endIcon={<AddIcon />}
            onClick={handleOpen}
          >
            Create New
          </Button>
        </Box>
      ) : (
        <Box
          sx={{ overflow: "scroll", height: " calc(100vh - 318px)" }}
          id="recentProjects"
        >
          {projects.map(
            (project, index) =>
              project?.id !== "sample-project" && (
                <Box

                // sx={{ marginBottom: "10%" }}
                >
                  <Box
                    onClick={() => {
                      navigate(`/project/${project.id}`);
                    }}
                    sx={{
                      padding: "12px 20px",
                      cursor: "pointer",
                      borderBttom: "1px solid #80808014",
                      boxShadow: "0 0px 4px #80808029",
                      "&:hover": {
                        background: "#80808014",
                      },
                    }}
                  >
                    <Box
                      sx={{ display: "flex", gap: "5px", alignItems: "center" }}
                    >
                      <span
                        style={{
                          background: `${
                            project && project.colour
                              ? project.colour
                              : "#e4e4e4"
                          }`,
                          borderRadius: " 50%",
                          width: "25px",
                          height: "26px",
                          textAlign: "center",
                          fontSize: "14px",
                          alignSelf: "center",
                          alignContent: "center",
                          fontWeight: "bold",
                        }}
                      >
                        {project.name.charAt(0)}
                      </span>
                      <Typography
                        sx={{
                          maxWidth: "230px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <abbr
                          // title={project.name}
                          style={{
                            textDecoration: "none",
                            fontWeight: "bold",
                            fontSize: "0.9rem",
                          }}
                        >
                          {project.name.charAt(0).toUpperCase() +
                            project.name.slice(1)}
                        </abbr>
                      </Typography>
                    </Box>
                    <Typography
                      sx={{
                        color: "#959BA3",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {project.description}
                    </Typography>

                    {project &&
                    project.annotatedImageCount &&
                    project.annotatedImageCount !== 0 &&
                    project.annotatedImageCount == project.images ? (
                      <Box
                        sx={{ display: "flex", gap: "10px", marginTop: "15px" }}
                      >
                        <Typography
                          sx={{
                            background: "#EDFAF6",
                            padding: "5px 10px",
                            fontSize: "12px",
                            borderRadius: "18px",
                          }}
                        >
                          Completed
                        </Typography>
                      </Box>
                    ) : (
                      <Box
                        sx={{ display: "flex", gap: "10px", marginTop: "10px" }}
                      >
                        <Typography
                          sx={{
                            background: "#FBE4E1",
                            padding: "5px 10px",
                            fontSize: "12px",
                            borderRadius: "18px",
                          }}
                        >
                          <span
                            style={{ color: "#fe7979", marginRight: "3px" }}
                          >
                            {100 -
                              (project &&
                              project.annotatedImageCount &&
                              project.images
                                ? Math.round(
                                    (project.annotatedImageCount /
                                      project.images) *
                                      100
                                  )
                                : 0)}
                            %
                          </span>
                          Remaining
                        </Typography>
                        <Typography
                          sx={{
                            background: "#EDFAF6",
                            padding: "5px 10px",
                            fontSize: "12px",
                            borderRadius: "18px",
                          }}
                        >
                          <span
                            style={{ color: "#2bed83", marginRight: "3px" }}
                          >
                            {project.annotatedImageCount} / {project.images}
                          </span>
                          Annotated
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Box>
              )
          )}
        </Box>
      )}

      <VisionStudioProject
        setOpen={setOpen}
        open={open}
        handleClose={handleClose}
      />
    </Box>
  );
};

export default RecentProjects;
